import { render } from "./CheckoutThankYouView.vue?vue&type=template&id=1f34af98&ts=true"
import script from "./CheckoutThankYouView.vue?vue&type=script&lang=ts"
export * from "./CheckoutThankYouView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__